export const isMacOs = () => navigator.userAgent.indexOf('Mac') !== -1
